import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import { Editor } from "@tinymce/tinymce-react";
import { uploadFile } from "../../utils/upload";

export const BlogEditor = forwardRef(({ handleChange, initialValue }, ref) => {
  const editorRef = useRef(null);
  const handleEditorChange = (content, editor) => {
    handleChange(content, editor.getContent());
  };
  // const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    // setRefreshKey(+new Date());
  }, [initialValue]);

  useImperativeHandle(ref, () => editorRef.current);

  return (
    <Editor
      value={initialValue}
      ref={editorRef}
      key={"k6gw3kfaydu2z2dutbh7cxc8wrdrsw7m5vbxx27o84iv7xau"}
      apiKey="k6gw3kfaydu2z2dutbh7cxc8wrdrsw7m5vbxx27o84iv7xau"
      init={{
        relative_urls: false,
        lineheight_formats:
          "1 1.1 1.2 1.3 1.4 1.5 1.6 1.75 2 2.1 2.2 2.3 2.4 2.5 2.6 2.7 2.8 2.9 3",
        codesample_languages: [
          { text: "HTML/XML", value: "markup" },
          { text: "JavaScript", value: "javascript" },
          { text: "CSS", value: "css" },
          { text: "PHP", value: "php" },
          { text: "Ruby", value: "ruby" },
          { text: "Python", value: "python" },
          { text: "Java", value: "java" },
          { text: "C", value: "c" },
          { text: "C#", value: "csharp" },
          { text: "C++", value: "cpp" },
          { text: "bash", value: "shell" },
        ],
        content_style: `.mce-content-body:not([dir=rtl]) blockquote {
          display: block;
          border-left: 8px solid #d0e5f2;
          padding: 5px 10px;
          margin: 10px 0;
          line-height: 1.4;
          font-size: 100%;
          background-color: #f1f1f1;
        }`,
        images_upload_handler: (blobInfo, success, failure) => {
          uploadFile(blobInfo.blob())
            .then((data) => success(data.url))
            .catch((e) => failure(e));
        },
        fontsize_formats: "8px 10px 12px 14px 16px 18px 24px 36px 48px",
        placeholder: "请输入正文（不得少于 200 字）",
        height: "100%",
        menubar: false,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code codesample fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        toolbar:
          "undo redo | fontsizeselect formatselect | bullist numlist outdent indent lineheight | alignleft aligncenter alignright alignjustify | link blockquote codesample image media table | removeformat |  bold italic backcolor | code preview fullscreen",
      }}
      onEditorChange={handleEditorChange}
    />
  );
});
